import { render, staticRenderFns } from "./impact-form-designer-read-only.vue?vue&type=template&id=4bef98bb&scoped=true&"
import script from "./impact-form-designer-read-only.vue?vue&type=script&lang=js&"
export * from "./impact-form-designer-read-only.vue?vue&type=script&lang=js&"
import style0 from "./impact-form-designer-read-only.vue?vue&type=style&index=0&id=4bef98bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef98bb",
  null
  
)

export default component.exports